export function filterDuplicates(array) {
    return [...new Set(array)];
}
